import { render, staticRenderFns } from "./tableRegisteredStudentsNoSelectable.vue?vue&type=template&id=254eced3&"
import script from "./tableRegisteredStudentsNoSelectable.js?vue&type=script&lang=js&"
export * from "./tableRegisteredStudentsNoSelectable.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports